export default __webpack_public_path__ + "static/media/loc-material-3.93f1ea7b.webp";